import type {ReactAction} from '@netx/core/bootstrap';
import {faSearch} from '@fortawesome/pro-solid-svg-icons';
import {SearchesSavedLabel} from '../locales';

export const searchesSavedActionRouteIcon = faSearch;

/**
 * Goto to saved searches
 * @param params
 * @returns Action
 */
export const searchesSavedActionRoute = (
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'searches-saved-route',
	cb: () => dispatcher.trigger('nx:searches'),
	icon: searchesSavedActionRouteIcon,
	get label() {
		return SearchesSavedLabel.ROUTE;
	},
	routeMatch: /^search\/saved(\/?)/,
	...params,
});

export default searchesSavedActionRoute;
